import React, { useEffect, useMemo, useState } from 'react';
import { Icon, Header, Message, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment';

const RecurringPaymentConfirmation = ({ source, data, actions, setLoading, loading }) => {
	const { policyNumber, policyId, clientId, policyImageNum } = data;

	const deductionDay = useMemo(() => moment(data.term.effectiveDate).date(), [data.term.effectiveDate]);
	const [error, setError] = useState(null);

	useEffect(() => {
		const load = async () => {
			try {
				setLoading(true);
				const result = await actions.addRecurringPayment({
					policyId,
					policyNumber,
					clientId,
					imageNumber: policyImageNum,
					source: {
						...source,
						type: (source.type !== 'check' && source.type !== 'credit') ?  source.fiserv.fundingCategory.toLowerCase(): (source.type === 'check' ? 'check' : 'credit')
					},
					deductionDay
				});
				setLoading(false);
				if (result.response && result.response.error) setError(result.response.error[0]);
			} catch (e) {
				setLoading(false);
				setError(e.error);
			}
		};

		load();
	}, [actions, clientId, policyImageNum, policyId, policyNumber, source, deductionDay, setLoading]);

	return (
		<div className='post-payment-confirmation'>
			{loading && (
				<div>
					<Dimmer active inverted>
						<Loader active size='massive'>
							Submitting Payment Information...
						</Loader>
					</Dimmer>
				</div>
			)}
			{error && !loading && (
				<React.Fragment>
					<Message error>Error: {error}</Message>
					<Icon name='times circle outline' size='massive' color='red' />
					<Header as='h1' content='Failed!' />
				</React.Fragment>
			)}
			{!error && !loading && (
				<div>
					<Icon name='check circle' size='massive' color='green' />
					<Header as='h1' content='Success!' />
				</div>
			)}
		</div>
	);
};

export default RecurringPaymentConfirmation;
